// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/main.css */
/* Força a visibilidade do texto dos links do menu */
.nav-link-title {
    display: inline-block !important;
    opacity: 1 !important;
  }
  
/* Garante que os ícones estejam sempre visíveis */
.nav-link-icon {
    display: inline-block;
  }
  
/* Remove qualquer opacidade que o Tabler possa estar aplicando */
.navbar-nav .nav-item .nav-link {
    opacity: 1 !important;
    visibility: visible !important;
  }
.nav-link.active {
    color: gray !important; /* Define a cor do texto */
    background-color: #f6f8fb; /* Define um fundo cinza claro, opcional */
    border-radius: 4px; /* Adiciona um arredondamento nos cantos, opcional */
}
/* Sobrescreve a cor da barra de navegação */
.navbar {
    --tblr-navbar-color: #c4cad4; /* Escolha uma cor visível, como branco */
  }
.footer {
  display: flex;
  justify-content: flex-end; /* Alinha o conteúdo à direita */
  padding: 1rem;
}
.footer .container-xl {
  display: flex;
  justify-content: flex-end;
}
.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Ocupa a altura total da tela */
}
.page-body {
  flex: 1 1; /* Expande para ocupar o espaço disponível entre o header e o footer */
}
.footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
}
.footer .container-xl {
  display: flex;
  justify-content: flex-end;
}

.header {
  display: flex;
  justify-content: space-between; /* Alinha conteúdo às extremidades */
  align-items: center; /* Centraliza verticalmente */
  padding: 1rem;
  background-color: #f8f9fa; /* Exemplo de cor para o header */
  border-bottom: 0.3px solid #dee2e6; /* Linha inferior */
}

.header .user-welcome {
  font-weight: normal;
}

.header .logout-btn {
  margin-left: auto; /* Empurra o botão para o lado direito */
}

.alert-float {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  min-width: 250px;
  transition: opacity 0.5s ease-in-out;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  padding: 10px;
  border-radius: 5px;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 10px;
  border-radius: 5px;
}

.ts-wrapper .ts-control {
  position: relative;
  display: flex;
  align-items: center;
}

.ts-wrapper .ts-dropdown {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.ts-wrapper .ts-dropdown li {
  padding: 8px 16px;
  cursor: pointer;
}

.ts-wrapper .ts-dropdown li:hover {
  background: #f7f7f7;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,oDAAoD;AACpD;IACI,gCAAgC;IAChC,qBAAqB;EACvB;;AAEF,kDAAkD;AAClD;IACI,qBAAqB;EACvB;;AAEF,iEAAiE;AACjE;IACI,qBAAqB;IACrB,8BAA8B;EAChC;AACF;IACI,sBAAsB,EAAE,0BAA0B;IAClD,yBAAyB,EAAE,0CAA0C;IACrE,kBAAkB,EAAE,oDAAoD;AAC5E;AACA,4CAA4C;AAC5C;IACI,4BAA4B,EAAE,yCAAyC;EACzE;AACF;EACE,aAAa;EACb,yBAAyB,EAAE,gCAAgC;EAC3D,aAAa;AACf;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,iCAAiC;AACtD;AACA;EACE,SAAO,EAAE,sEAAsE;AACjF;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,oCAAoC;EACpE,mBAAmB,EAAE,6BAA6B;EAClD,aAAa;EACb,yBAAyB,EAAE,iCAAiC;EAC5D,kCAAkC,EAAE,mBAAmB;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* src/styles/main.css */\n/* Força a visibilidade do texto dos links do menu */\n.nav-link-title {\n    display: inline-block !important;\n    opacity: 1 !important;\n  }\n  \n/* Garante que os ícones estejam sempre visíveis */\n.nav-link-icon {\n    display: inline-block;\n  }\n  \n/* Remove qualquer opacidade que o Tabler possa estar aplicando */\n.navbar-nav .nav-item .nav-link {\n    opacity: 1 !important;\n    visibility: visible !important;\n  }\n.nav-link.active {\n    color: gray !important; /* Define a cor do texto */\n    background-color: #f6f8fb; /* Define um fundo cinza claro, opcional */\n    border-radius: 4px; /* Adiciona um arredondamento nos cantos, opcional */\n}\n/* Sobrescreve a cor da barra de navegação */\n.navbar {\n    --tblr-navbar-color: #c4cad4; /* Escolha uma cor visível, como branco */\n  }\n.footer {\n  display: flex;\n  justify-content: flex-end; /* Alinha o conteúdo à direita */\n  padding: 1rem;\n}\n.footer .container-xl {\n  display: flex;\n  justify-content: flex-end;\n}\n.page-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh; /* Ocupa a altura total da tela */\n}\n.page-body {\n  flex: 1; /* Expande para ocupar o espaço disponível entre o header e o footer */\n}\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem;\n}\n.footer .container-xl {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between; /* Alinha conteúdo às extremidades */\n  align-items: center; /* Centraliza verticalmente */\n  padding: 1rem;\n  background-color: #f8f9fa; /* Exemplo de cor para o header */\n  border-bottom: 0.3px solid #dee2e6; /* Linha inferior */\n}\n\n.header .user-welcome {\n  font-weight: normal;\n}\n\n.header .logout-btn {\n  margin-left: auto; /* Empurra o botão para o lado direito */\n}\n\n.alert-float {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 1000;\n  min-width: 250px;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.alert-success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.ts-wrapper .ts-control {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.ts-wrapper .ts-dropdown {\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.ts-wrapper .ts-dropdown li {\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.ts-wrapper .ts-dropdown li:hover {\n  background: #f7f7f7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
